"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function PolTicaDePrivacidad() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const {
    ref: barRef,
    isVisible: barVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: signatureRef,
    isVisible: signatureVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="4124" id="política-de-privacidad" className="relative bg-background text-foreground min-h-screen py-24 md:py-32 px-6 md:px-12 lg:px-20 overflow-hidden">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' /%3E%3C/svg%3E\")"
    }} />

      <div className="relative mx-auto max-w-[1400px]">
        <div ref={labelRef} className={`flex justify-start mb-12 transition-all duration-700 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"}`}>
          <span className="font-mono text-[12px] tracking-[0.4em] uppercase text-primary">POLITICA DE PRIVACIDAD </span>
        </div>

        

        <div ref={bodyRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-16 mb-32 transition-all duration-1000 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32 space-y-8">
              <div className="space-y-4">
                <h3 className="font-mono text-sm uppercase tracking-widest text-primary">NUESTRA POLITICA</h3>
                
              </div>
              <div className="h-px w-full bg-border" />
              
            </div>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            <div className="space-y-20">
              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">01</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Identidad del responsable del tratamiento</h3>
                </div>
                <div className="space-y-6 text-lg leading-relaxed opacity-80">
                  <p>El presente sitio web y los servicios asociados a la marca TIMEARRIVAL son operados por Leads Media Digital LLC, sociedad constituida conforme a las leyes del Estado de Delaware (Estados Unidos). Correo electrónico de contacto: contacto@timearrival.com</p>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">02</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Alcance de esta Política de Privacidad</h3>
                </div>
                <p className="text-lg leading-relaxed opacity-80">Esta Política de Privacidad describe cómo TIMEARRIVAL recopila, utiliza y protege la información asociada al uso de su plataforma de gestión y optimización logística a través de software como servicio (SaaS). TIMEARRIVAL ofrece soluciones de optimización y gestión logística destinadas tanto a usuarios particulares como a empresas.</p>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">03</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Información que recopilamos</h3>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">03.1</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Información que NO recopilamos</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>TIMEARRIVAL no recopila ni trata directamente:</p>
                  <ul className="list-none space-y-2">
                    <li>• Datos personales sensibles</li>
                    <li>• Datos biométricos</li>
                    <li>• Datos de localización de personas físicas</li>
                    <li>• Datos de dispositivos móviles personales</li>
                    <li>• Información de navegación mediante cookies, píxeles o tecnologías de seguimiento</li>
                  </ul>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">03.2</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Información que SÍ recopilamos</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>En el marco de la prestación del servicio, podemos recopilar y procesar:</p>
                  <ul className="list-none space-y-2">
                    <li>• Datos de localización en tiempo real&nbsp;</li>
                    <li>• Historial de rutas, paradas y trayectos</li>
                    <li>• Información técnica&nbsp;</li>
                    <li>• Datos operativos de la flota (cuando aplique)</li>
                    <li>• Información básica de contacto proporcionada voluntariamente por el cliente (por ejemplo, correo electrónico para soporte)</li>
                  </ul>
                  <p>Estos datos están vinculados al activo, no a la identidad personal del conductor u ocupantes.</p>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">04</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Finalidad del tratamiento de la información</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>La información recopilada se utiliza exclusivamente para:</p>
                  <ul className="list-none space-y-2">
                    <li>• Prestar el servicio contratado</li>
                    <li>• Permitir al usuario acceder a informes, mapas y funcionalidades del software</li>
                    <li>• Gestionar la relación contractual y el soporte técnico</li>
                    <li>• Mejorar la estabilidad, seguridad y funcionamiento del servicio</li>
                    <li>• Cumplir con obligaciones legales aplicables</li>
                  </ul>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">05</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Base legal del tratamiento</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>El tratamiento de la información se basa en:</p>
                  <ul className="list-none space-y-2">
                    <li>• La ejecución de un contrato de prestación de servicios</li>
                    <li>• El interés legítimo de TIMEARRIVAL en operar, mantener y mejorar su plataforma</li>
                    <li>• El cumplimiento de obligaciones legales aplicables en la jurisdicción correspondiente</li>
                  </ul>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">06</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight"> Responsabilidad del usuario y uso lícito</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>El usuario reconoce y acepta que: Es el único responsable de garantizar que tiene derecho legal a usar el SaaS. En caso de activos conducidos por terceros , el usuario es responsable de: Informar adecuadamente sobre la existencia del SaaS. Obtener los consentimientos que resulten legalmente exigibles según la normativa local aplicable. TIMEARRIVAL no supervisa ni controla el uso que cada cliente realiza del servicio y no asume responsabilidad por usos ilícitos, indebidos o no autorizados.</p>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">07</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Compartición de información con terceros</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>TIMEARRIVAL podrá compartir información técnica y operativa únicamente con:

Proveedores de infraestructura tecnológica
Servicios de alojamiento, servidores o mantenimiento
Proveedores necesarios para la correcta prestación del servicio
En ningún caso se venderá ni cederá información a terceros con fines comerciales ajenos al servicio.</p>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">08</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Seguridad de la información</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>TIMEARRIVAL implementa medidas técnicas y organizativas razonables para proteger la información frente a accesos no autorizados, pérdida, alteración o divulgación indebida.

No obstante, el usuario reconoce que ningún sistema es completamente seguro y que el uso del servicio se realiza bajo su propia responsabilidad.</p>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">09</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Conservación de los datos</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>La información se conservará únicamente durante el tiempo necesario para:

Prestar el servicio contratado
Cumplir con obligaciones legales
Resolver posibles reclamaciones
Una vez finalizada la relación contractual, los datos podrán ser eliminados o anonimizados conforme a las políticas internas de TIMEARRIVAL.</p>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">10</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight"> Derechos de los usuarios</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>Cuando resulte aplicable conforme a la legislación vigente, los usuarios podrán solicitar:

Acceso a la información asociada a su cuenta
Corrección de datos inexactos
Eliminación de información no necesaria
Las solicitudes deberán enviarse a contacto@timearrival.com.

                </p>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">11</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Cambios en la Política de Privacidad</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>TIMEARRIVAL se reserva el derecho de modificar esta Política de Privacidad en cualquier momento.
Las versiones actualizadas se publicarán en esta página y entrarán en vigor desde su publicación.</p>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-primary text-sm">12</span>
                  <h3 className="font-default font-bold text-3xl uppercase tracking-tight">Contacto</h3>
                </div>
                <div className="text-lg leading-relaxed opacity-80 space-y-4">
                  <p>Para cualquier consulta relacionada con esta Política de Privacidad, puede contactarnos en:

 contacto@timearrival.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ref={signatureRef} className={`pt-16 border-t border-border transition-all duration-1000 ease-out ${signatureVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
            <div>
              
              <p className="font-mono text-sm">JUNIO 2026</p>
            </div>
            <div className="flex gap-8">
              <div className="text-right">
                
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}